import type { AdaptiveRevealConfig } from '../cinematic/adaptive/adaptiveConfig';
import type { CompositionAlignment } from '../cinematic/adaptive/AdaptiveMessageBody';
import type { RevealStyleId } from '../cinematic/adaptive/revealStyles';

export interface FullCanvasSceneProps {
  recipientName: string;
  relationship: string;
  message: string;
  photoUrls?: string[];
  publishedDate?: string;
  senderLabel?: string;
  onComplete: () => void;
  /** Adaptive reveal config — when present, drives reading rhythm, layout, pacing */
  config?: AdaptiveRevealConfig;
  /** True when the shell already played the full cinematic photo sequence. */
  startAtMessage?: boolean;
}

/** Map style preset → message body alignment variant. */
export const STYLE_ALIGNMENT: Record<RevealStyleId, CompositionAlignment> = {
  ethereal_memory: 'centered',
  luxury_editorial: 'editorial-grid',
  emotional_film: 'cinematic-stack',
  intimate_letter: 'framed',
  modern_futuristic: 'asymmetric-left',
};
